import { RequestInterceptor, ResponseInterceptor } from 'react-fetching-library';
import store from '../../store';
import { ENV } from '../../config/env';
import { AuthUtils } from '../../utils/auth';
import { message } from 'antd';

export const requestHostInterceptor: () => RequestInterceptor = () => () => async (action: any) => {
  let token = (action as any).token;
  if (!token) {
    token = AuthUtils.getToken();
  }

  console.log(ENV.API_URL, token);

  // Get selected server code from Redux store
  const state = store.getState();
  const selectedServerCode = state.server.selectedServer?.code;

  return {
    ...action,
    endpoint: action.endpoint.startsWith('http') ? action.endpoint : `${ENV.API_URL}${action.endpoint}`,
    headers: {
      ...(action.headers || {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }),
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...(selectedServerCode ? { 'X-Server-Code': selectedServerCode } : {}),
    },
  };
};
